import Spinner from './component';

export default Spinner;
